import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { createContext } from '@costar-ui/utils';

var _createContext = createContext({
    strict: false,
    name: 'Card Context'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  CardContextProvider = _createContext2[0],
  useCardContext = _createContext2[1];

// private context should only be consumed by within a popover component hierarchy only.
var CardContextProvider$1 = CardContextProvider;

export { CardContextProvider$1 as default, useCardContext };
//# sourceMappingURL=card-context.esm.js.map
